import React from "react";
import { Alert, Box } from "@mui/material";
import QRCode from "react-qr-code";
import { API_ENDPOINT, BADGE_BG } from "../../../constants/constants";
import MuPb from "../../../widgets/MuPb";
import { useQuery } from "../../../utility/utility";
import useUserUrlGet from "../../../hooks/useUserUrlToken";

export const ViewBadgeMobile = () => {
  const query = useQuery();
  const id = query.get("id");
  const HEADER = {
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${id}`,
    },
  };
  const {
    data: user,
    isLoading,
    isError,
    error,
  } = useUserUrlGet(`${API_ENDPOINT}/user/badge-view`, HEADER);

  const style = {
    badgeContainer: {
      marginTop: "16px",
      marginLeft: "auto",
      marginRight: "auto",
      position: "relative",
      width: "8cm",
      height: "11.2cm",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      color: "black",
      boxSizing: "border-box",
    },
    detailsContainer: {
      textAlign: "center",
      marginTop: "4cm",
    },
    qrCode: {
      marginLeft: "auto",
      marginRight: "auto",
      display: "block",
      marginTop: "0.5cm",
      width: "2cm",
      height: "2cm",
    },
  };

  if (isLoading) {
    return <MuPb />;
  }

  if (isError) {
    return <Alert severity="error">Could not load due to some error</Alert>;
  }

  return (
    <div style={style.badgeContainer}>
      <div style={style.detailsContainer}>
        {/* Use badgeBg from the API, fallback to BADGE_BG constant */}
        <img
          src={user?.badgeBg || BADGE_BG}
          alt="Badge Background"
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 1,
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: "3.5cm",
            left: ".2cm",
            right: ".2cm",
            bottom: "1cm",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            zIndex: 2,
          }}
        >
          <Box sx={{ fontWeight: "bold", fontSize: "16px", mt: 4 }}>
            {`${user?.firstName?.toUpperCase() || ""} ${
              user?.lastName?.toUpperCase() || ""
            }`}
          </Box>
          <Box sx={{ fontWeight: "bold", fontSize: "17px", mt: 1 }}>
            {`${user?.companyName?.toUpperCase() || ""}`}
          </Box>
          <Box mt={2}>
            {user?.barcode_id && <QRCode value={user.barcode_id} size={116} />}
          </Box>
        </Box>
      </div>
      <div />
    </div>
  );
};
